import { useSelector } from 'react-redux';
import { isExperimentActive, getParameter } from '../../store/experiments/selectors';
import { EventName } from '../../tracking/EventName';
import { getTracker } from '../../tracking/getTracker';
import { getHasExposureBeenTracked, setHasExposureBeenTracked } from '../useExperiment';
export const trackExposure = (shouldTrackExposure, parameter, experimentKey) => {
  const hasExposureBeenTracked = getHasExposureBeenTracked(experimentKey);
  if (shouldTrackExposure && !hasExposureBeenTracked) {
    getTracker().track(EventName.ExperimentExposure, {
      action: `${experimentKey}-group-${parameter}`
    }, true);
    setHasExposureBeenTracked(experimentKey);
  }
};
export const useShouldTrackExperiment = experimentKey => {
  const shouldTrackExposure = useSelector(state => isExperimentActive(state, experimentKey));
  const parameter = useSelector(state => getParameter(state, experimentKey));
  const trackExperimentExposure = () => {
    trackExposure(shouldTrackExposure, parameter, experimentKey);
  };
  return {
    trackExperimentExposure
  };
};